
export default "/assets/subscript.72774d67.svg"